<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo5.jpg" style="background-image: url('assets/img/fondo5.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Plan Maestro del Centro Histórico de Cusco - TOMO I
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section mt-80 mt-md-30 mt-sm-30 mb-10" style="background-image: url('/assets/img/fondo-tomo1.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 m-auto text-center">
        <div class="section-title-wrap">
          <h2>TOMO I</h2>
          <p class="mb-0" style="font-weight: 300">
            Actualización del Plan Maestro del Centro Histórico del Cusco 2018 -
            2028, elavorado por la Municipalidad del Cusco en coordinación con
            la población en general y con todas aquellas instituciones y
            organizaciones involucradas con la protección del patrimonio
            cultural de nuestra ciudad.
          </p>
        </div>
        <iframe style="width: 100%; height: 600px;" src="http://online.anyflip.com/rhspq/hlis/" seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe>
        <div class="section-title-wrap mt-60">
          <h2>Mapas del Plan Maestro TOMO I</h2>
          <p class="mb-0" style="font-weight: 300">
            El Tomo I del plan maestro del Centro Histórico del Cusco, viene
            acompañando de 13 mapas, con distintas características, colocados a
            continuación.
          </p>
        </div>

      </div>
    </div>
  </div>
</section>
<div class="page-wrapper" style="background-image: url('/assets/img/fondo-puente-rosario.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mt-10 mt-md-10 mt-sm-10 mb-120 mb-md-80 mb-sm-60">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto">
          <!-- Start Accordion Element #01 -->
          <div class="accordion-element-1">
            <div class="restaurant-why-us-accordion" id="accordionOne">
              <!-- Start Accordion item #01 -->
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#tomo1" style="color:white">
                    <span>01.</span> Plan Maestro - Tomo I
                  </h3>
                </div>
                <div id="tomo1" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/TOMO-I.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#uno" style="color:white">
                    <span>02.</span> PE-273 Cusco WGS84 Model (1)
                  </h3>
                </div>
                <div id="uno" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PE-273 Cusco WGS84 Model (1).pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #02 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h3 data-toggle="collapse" data-target="#dos" style="color:white">
                    <span>03.</span>PLANO BASE UNESCO
                  </h3>
                </div>
                <div id="dos" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PLANO BASE UNESCO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #03 -->
              <div class="card">
                <div class="card-header" id="headingThree">
                  <h3 data-toggle="collapse" data-target="#tres" style="color:white">
                    <span>04.</span> PP-01 DELIMITACION
                  </h3>
                </div>
                <div id="tres" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-01 DELIMITACION.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #04 -->
              <div class="card">
                <div class="card-header" id="headingFour">
                  <h3 data-toggle="collapse" data-target="#cuatro" style="color:white">
                    <span>05.</span> PP-02 SECTORES PARA LA GESTION
                  </h3>
                </div>
                <div id="cuatro" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-02 SECTORES PARA LA GESTION.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#cinco" style="color:white">
                    <span>06.</span> PP-03 MOVILIDAD Y ACCESIBILIDAD
                  </h3>
                </div>
                <div id="cinco" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-03 MOVILIDAD Y ACCESIBILIDAD.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#seis" style="color:white">
                    <span>07.</span> PP-04 ANILLO VIAL
                  </h3>
                </div>
                <div id="seis" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-04 ANILLO VIAL.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#siete" style="color:white">
                    <span>08.</span> PP-05 MACRO MANZANAS
                  </h3>
                </div>
                <div id="siete" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-05 MACRO MANZANAS.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#ocho" style="color:white">
                    <span>09.</span> PP-06 CATEGORIAS DE CATALOGACION DE INMUEBLES
                  </h3>
                </div>
                <div id="ocho" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-06 CATEGORIAS DE CATALOGACION DE INMUEBLES.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#nueve" style="color:white">
                    <span>10.</span> PP-07 AREAS TRATAMIENTO PREFERENCIAL POR MANZANAS Y AMBIENTES URBANOS
                  </h3>
                </div>
                <div id="nueve" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-07 AREAS TRATAMIENTO PREFERENCIAL POR MANZANAS Y AMBIENTES URBANOS.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#diez" style="color:white">
                    <span>11.</span> PP-08 INMUEBLES MONUMENTALES Y PATRIMONIALES DE INTERVENCION PRIORITARIA
                  </h3>
                </div>
                <div id="diez" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-08 INMUEBLES MONUMENTALES Y PATRIMONIALES DE INTERVENCION PRIORITARIA.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#once" style="color:white">
                    <span>12.</span> PP-09 EQUIPAMIENTO URBANO
                  </h3>
                </div>
                <div id="once" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-09 EQUIPAMIENTO URBANO.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#doce" style="color:white">
                    <span>13.</span> PP-10 MOVILIDAD Y ESPACIOS PUBLICOS
                  </h3>
                </div>
                <div id="doce" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-10 MOVILIDAD Y ESPACIOS PUBLICOS.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#trece" style="color:white">
                    <span>14.</span> PP-11 AMBITO DE PROTECCION AMBIENTAL
                  </h3>
                </div>
                <div id="trece" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <iframe src="/assets/pdf/tomo-1/PP-11 AMBITO DE PROTECCION AMBIENTAL.pdf" width="100%" height="680px"></iframe>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
